import React from "react";
import "../styles/Branches.css"; // External CSS (see below)

const Branches = () => {
  const branches = [
    {
      name: "Pune — Spandan Blood Centre",
      address: "Mundhwa-Kharad road opp H.P petrol pump Khardi, Pune",
      phone: "+91 9607353233/9607453233",
    },
    {
      name: "Sangola  — Revneel Blood Centre",
      address: "Near Bus Stand, Kadlas Naka, Sangola, Maharashtra 413307",
      phone: "",
    },
    {
      name: "Indapur  — Muktai Blood Centre",
      address: "Kalthan, Indapur, Maharashtra 413106",
      phone: "",
    },
        {
      name: "Gokak  — Gokak Blood Centre",
      address: "Mobile van services — schedule on requestLaxmi Temple Rd, Court Circle, Gokak, Karnataka 591307",
      phone: "+91 83322 26600",
    },
        {
      name: "Nipani  — Ankur Blood Centre",
      address: "First Floor, Gomatesh Arcade, R K Colony, Chikodi, Karnataka 591201",
      phone: "+91 8951230706",
    },
        {
      name: "Vaduj  — Ayush Blood Centre",
      address: " Vaduj - Dahiwadi Rd, Talathi Colony, Vaduj, Maharashtra 415506",
      phone: "",
    },
  ];

  return (
    <div className="branches-page">
      {/* ✅ Hero Section */}
      <section className="hero">
        <h2>Our Branches</h2>
        <p>
          We operate through multiple branches to serve the community better.
        </p>
      </section>

      {/* ✅ Branch Cards */}
      <main className="container-branches">
        <div className="branch-list">
          {branches.map((branch, index) => (
            <div key={index} className="branch">
              <h4>{branch.name}</h4>
              <div>{branch.address}</div>
              <div className="phone">
                <strong>Phone:</strong> {branch.phone}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Branches;
